import { z } from "zod";

export const emailPasswordResetSchema = z.object({
	email: z.string().email(),
});

export type EmailPasswordSchema = z.infer<typeof emailPasswordResetSchema>;

const strongPassword = z
	.string()
	.min(8, "Password must be at least 8 characters long")
	.regex(/[A-Z]/, "Password must contain an uppercase letter")
	.regex(/[a-z]/, "Password must contain a lowercase letter")
	.regex(/[0-9]/, "Password must contain a number")
	.regex(/[^A-Za-z0-9]/, "Password must contain a special character");

export const forgotPasswordCompleteSchema = z
	.object({
		newPassword: strongPassword,
		confirmPassword: strongPassword,
	})
	.refine((data) => data.newPassword === data.confirmPassword, {
		message: "Passwords do not match",
		path: ["confirmPassword"],
	});

export type ForgotPasswordCompleteSchema = z.infer<
	typeof forgotPasswordCompleteSchema
>;
